import { Box } from '@mui/material';
import styled from 'styled-components';
export const ModalContainer = styled(Box)`
  z-index: 1;
  position: absolute;
  top: 5%;
  left: 5%;
  padding: 2px;
  border-radius: 8px;
  background-color: white;
  min-width: 150px;
  height: 80px;
  display: flex;
  align-items: end;

  @media (max-width: 600px) {
    width: 200px;
    height: 75px;
  }
`;

export const CloseWrapper = styled(Box)`
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 3;
`;
